import css from 'styled-jsx/css';

const styles = css`.remove-button{font-size:.875rem;line-height:1.4285714286;font-family:"Inter",sans-serif;font-weight:400;text-transform:none}.remove-button{font-weight:500}.remove-button:hover{cursor:pointer}.remove-button :global(i){margin-right:.25rem}`;

export default styles;